<div class="form-group">
  <!-- ID Type -->
  <div class="form-group my-2">
    <label class="file-upload-label mb-1 required">ID Type Format</label>
    <hr class="mb-2 fw-light" />
    <div class="d-flex flex-column">
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="id-type-radio"
          id="idBook"
          value="ID Book"
          v-model="id_type"
        />
        <label class="form-check-label" for="idBook">ID Book</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          name="id-type-radio"
          id="idCard"
          value="ID Card"
          v-model="id_type"
        />
        <label class="form-check-label" for="idCard">ID Card</label>
      </div>
    </div>
  </div>
  <!-- File Sections -->
  <div v-for="(files, key) in all_files" :key="key">
    <div v-if="should_show_section(key)" class="my-2">
      <label class="file-upload-label" :class="{ 'required': is_required_document(key) }"
        >{{ get_label(key) }}
        <span class="text-muted text-xs fw-normal"
          >({{ max_files[key] }} files - Max)</span
        >
      </label>
      <small class="text-xs" v-if="key == 'PROOFOFRESIDENCE'">
        <b class="text-danger">Warning</b>: 
        Please Only Provide Proof Of Address Stating Your Full Name.
        <br>
        Statements Only No Invoices
      </small>
      <hr class="mb-2 fw-light" />
      <div class="file-upload-container w-100 mx-auto">
        <div class="custom-file-upload">
          <div
            class="upload-header"
            :class="{ 'has-file': files.length > 0, 'drag-over': is_dragging[key] }"
            @dragover.prevent="is_dragging[key] = true"
            @dragleave.prevent="is_dragging[key] = false"
            @drop.prevent="handle_file_drop($event, key)"
          >
            <div v-if="files.length === 0" class="upload-placeholder">
              <p class="mb-2 mt-3 fw-bold text-xs">
                Drag and drop your {{ get_label(key).toLowerCase() }} files here
              </p>
              <p class="text-muted small text-xxs mb-3">or</p>
              <button
                type="button"
                class="btn btn-bg-green px-4 py-2 rounded-small fw-bold text-xxs"
                @click="$refs[key + '_input'][0].click()"
              >
                Browse Files
              </button>
              <p class="text-muted mt-3 small text-xxs">
                Supported formats: PDF, JPG, JPEG, PNG
              </p>
              <p class="text-muted small text-xxs">
                You can upload {{ max_files[key] > 1 ? 'multiple files (Max ' +
                max_files[key] + ')' : '1 file' }}
              </p>
            </div>
            <div v-else class="selected-files-container">
              <div class="my-1 text-center">
                <p class="fw-bold text-xs">
                  <i class="fas fa-check-circle text-success me-2"></i>
                  {{ files.length }} {{ files.length === 1 ? 'file' : 'files' }}
                  successfully uploaded
                </p>
              </div>              <div class="selected-files-list">
                <div
                  v-for="(file, i) in files"
                  :key="i"
                  class="selected-file-item mb-2"
                >
                  <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                    <i class="fas fa-file-alt me-2 text-primary flex-shrink-0"></i>
                    <span class="text-truncate file-name" :title="file.name"
                      >{{ file.name }}</span
                    >
                    <span
                      v-if="file.is_existing"
                      class="badge bg-info ms-2 text-xxs flex-shrink-0"
                      >Existing</span
                    >
                  </div>
                  <div class="file-actions">
                    <span class="file-size me-2 text-muted text-xxs"
                      >{{ format_file_size(file.size) }}</span
                    >
                    <button
                      type="button"
                      class="btn btn-sm text-primary p-0 me-2"
                      @click="view_file(file)"
                      title="View file"
                    >
                      <i class="fas fa-download"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm text-danger p-0"
                      @click="remove_file(key, i)"
                      title="Remove file"
                    >
                      <i class="fas fa-times-circle"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="text-center mt-3"
                v-if="files.length < max_files[key]"
              >
                <button
                  type="button"
                  class="btn btn-bg-green btn-sm px-3 py-1 rounded-small fw-bold text-xxs"
                  @click="$refs[key + '_input'][0].click()"
                >
                  Add More Files
                </button>
              </div>
            </div>
          </div>
          <input
            :ref="key + '_input'"
            type="file"
            :id="key"
            class="d-none"
            @change="handle_file_change($event, key)"
            accept=".pdf,.jpg,.jpeg,.png"
            :multiple="max_files[key] > 1"
          />
        </div>
        <small
          v-if="error_messages[key]"
          class="form-text text-danger mt-2 d-block"
        >
          {{ error_messages[key] }}
        </small>
      </div>
    </div>
  </div>

  <!-- Submit -->
  <div class="text-end mt-4">
    <button
      type="button"
      @click="previous"
      class="btn btn-bg-secondary text-xs rounded-small shadow-sm me-1"
    >
      Previous
    </button>
    <button
      type="button"
      :disabled="!all_required_filled || is_loading==true"
      @click="upload_documents"
      class="btn btn-bg-green text-xs rounded-small shadow-sm"
    >
      Complete Application
    </button>
  </div>
</div>
